import { Checkbox as MuiCheckbox, CheckboxProps } from '@mui/material';

// Reference: https://mui.com/material-ui/api/checkbox/
const FormCheckbox = ({ ...props }: CheckboxProps) => {
  return <MuiCheckbox {...props} />;
};

export { FormCheckbox };
